var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e125e7b2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "upload-wrapper" };
const _hoisted_2 = { class: "drop-area" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "drop-area-item" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fal fa-arrow-alt-from-top" })
], -1 /* HOISTED */));
const _hoisted_4 = { class: "drop-area-item" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "drop-area-item" }, [
    /*#__PURE__*/ _createElementVNode("small", null, "or")
], -1 /* HOISTED */));
const _hoisted_6 = { class: "drop-area-item" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "drop-area-item" }, [
    /*#__PURE__*/ _createElementVNode("small", null, [
        /*#__PURE__*/ _createElementVNode("p", { class: "drop-note" }, [
            /*#__PURE__*/ _createElementVNode("i", { class: "fal fa-arrow-alt-from-top" }),
            /*#__PURE__*/ _createTextVNode(" Drop your file here ")
        ])
    ])
], -1 /* HOISTED */));
const _hoisted_8 = {
    key: 0,
    class: "file-name"
};
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fal fa-file" }, null, -1 /* HOISTED */));
import { ElUpload } from "element-plus";
import { ref } from "vue";
import Button from "../Button.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UploadFileWrapper',
    props: {
        acceptFormats: { default: () => [".csv", ".psv", ".json"] },
        note: { default: "Please note: it may take time to process your file." }
    },
    emits: ["uploaded", "removed"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const emit = __emit;
        const uploadedFile = ref(null);
        const handleChange = (file) => __awaiter(this, void 0, void 0, function* () {
            uploadedFile.value = file;
            if (file.raw) {
                emit("uploaded", file.raw);
            }
        });
        const handleRemove = () => {
            uploadedFile.value = null;
            emit("removed");
        };
        const formatSizeUnits = (bytes) => {
            if (!bytes || bytes === 0) {
                return "0 Bytes";
            }
            const bytesInKiloByte = 1024;
            const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
            const i = Math.floor(Math.log(bytes) / Math.log(bytesInKiloByte));
            return (parseFloat((bytes / Math.pow(bytesInKiloByte, i)).toFixed(2)) +
                " " +
                sizes[i]);
        };
        __expose({
            handleRemove,
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(ElUpload), {
                    action: "",
                    onChange: handleChange,
                    "on-remove": handleRemove,
                    drag: "",
                    "auto-upload": false,
                    "show-file-list": false,
                    accept: _ctx.acceptFormats.join(','),
                    class: _normalizeClass(["panel-wrapper inline-drop-area-wrapper", { 'with-file': uploadedFile.value }])
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            _hoisted_3,
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("p", null, [
                                    _createTextVNode(" Drop your "),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.acceptFormats, (format, index) => {
                                        return (_openBlock(), _createElementBlock("strong", { key: index }, _toDisplayString(index !== _ctx.acceptFormats.length - 1
                                            ? `${format.toUpperCase()}, `
                                            : format.toUpperCase()), 1 /* TEXT */));
                                    }), 128 /* KEYED_FRAGMENT */)),
                                    _createTextVNode(" file here ")
                                ])
                            ]),
                            _hoisted_5,
                            _createElementVNode("div", _hoisted_6, [
                                _createVNode(Button, { level: "secondary" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(" Browse Files ")
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _hoisted_7
                        ]),
                        (uploadedFile.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createElementVNode("small", null, [
                                    _hoisted_9,
                                    _createElementVNode("span", null, _toDisplayString(uploadedFile.value.name), 1 /* TEXT */),
                                    _createTextVNode(" (" + _toDisplayString(formatSizeUnits(uploadedFile.value.size)) + ")", 1 /* TEXT */)
                                ]),
                                _createElementVNode("i", {
                                    class: "fal fa-times",
                                    onClick: _withModifiers(handleRemove, ["stop"])
                                })
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["accept", "class"]),
                _createElementVNode("small", null, _toDisplayString(_ctx.note), 1 /* TEXT */)
            ]));
        };
    }
});
